export default {
  methods: {
    render_chart5(data) {
      let option = {
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              }
          },
          grid: {
            left: 20,
            bottom: 30,
            right: 20
          },
          xAxis: [
              {
                  type: 'category',
                  data: data.map(v=>v.time),
                  axisPointer: {
                      type: 'shadow',
                      label: {
                        fontFamily: 'PingFangSC',
                      } 
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgb(255,255,255,.6)',
                    fontFamily: 'PingFangSC',
                    interval: 0
                  },
                  axisLine: {
                    lineStyle: {
                      color: 'rgba(255,255,255,.15)'
                    }
                  }
              }
          ],
          yAxis: [
              {
                  type: 'value',
                  show: false,
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: 'rgba(65,210,144,.3)'
                    }
                  },
                  splitLine: { show: false },
                  minInterval: 1
              }
          ],
          series: [
            {
                name: '',
                type: 'bar',
                data: data.map(v=>v.dayNum),
                // itemStyle: {
                //   color: 'rgb(11,183,142)',
                //   barBorderRadius: [5,5,0,0]
                // },
                itemStyle: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: '#D4CC47' },
                      { offset: 1, color: '#FCF475' }]
                  },
                  barBorderRadius: [5,5,0,0]
                },
                barWidth: 20,
                label: {
                  show: true,
                  position: 'top',
                  color: '#FFFFFF',
                  fontFamily: 'PingFangSC',
                }
            }
          ],
          dataZoom: {
            type: 'inside',
            start: 0,
            end: 45
          }
      };
      let $instance = this.$echarts.init(this.$refs['chart5']);
      $instance.setOption(option);
    }
  }
}